import { render, staticRenderFns } from "./GainPointsClass.vue?vue&type=template&id=55f8911d&scoped=true&"
import script from "./GainPointsClass.vue?vue&type=script&lang=js&"
export * from "./GainPointsClass.vue?vue&type=script&lang=js&"
import style0 from "./GainPointsClass.vue?vue&type=style&index=0&id=55f8911d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f8911d",
  null
  
)

export default component.exports